export interface IClient {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  /** Telegram user id (рядок цифр) */
  telegramId?: string | null;
  createdAt: Date;
  updatedAt: Date;
  files: Array<string>;
  note: any;
  adress: any;
  premiumStatus: string;
  rents: Array<any>;

  cellAccess: boolean;
  adminAccess: boolean;
  cellStatus: CellStatus;
  otpCode: string | null;
  terminalUseLimitPerDay?: number;
}

export enum CellStatus {
  none = "none",
  state_1 = "state_1",
  state_2 = "state_2",
  state_3 = "state_3",
}

export interface IClientCreateDto {
  fullName: string;
  email: string;
  phone: string;
  telegramId?: string | null;
  note?: string;
  files?: Array<string>;
  cellAccess: boolean;
  adminAccess: boolean;
  terminalUseLimitPerDay?: number;
}

export const cellStatusTitle = (status: CellStatus): string => {
  switch (status) {
    case CellStatus.none:
      return "Відсутній";
    case CellStatus.state_1:
      return "Стан 1";
    case CellStatus.state_2:
      return "Стан 2";
    case CellStatus.state_3:
      return "Стан 3";
    default:
      return "Невідомий стан";
  }
};
